import React from "react";
import { Row, Col } from 'react-bootstrap';
import Button from '../UI/Button';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import classes from "./index.module.scss";
import TextInput from '../UI/TextInput';
import PasswordInput from '../UI/PasswordInput';

const SignInForm = ({ onSubmit, loading }) => {
  const { register, handleSubmit, errors } = useForm();
  
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset>
          <label htmlFor="username_email">Email or User Name</label>
          <TextInput 
            name="username_email"
            type="text"
            register={register({ required: true })}
            label="Email or Phone Number"
          />
          {errors.username_email && 
            <p className="warnMessage">This field is required</p>
          }
        </fieldset>
        <fieldset>
          <label htmlFor="password">Password</label>
          <PasswordInput 
            name="password"
            type="password"
            register={register({ 
              required: "You must specify a password", 
              minLength: {
                value: 8,
                message: "Password must have at least 8 characters"
              }
            })}
          />
          {errors.password && errors.password.type === "required" &&
            <p className="warnMessage">This field is required</p>
          }
          {errors.password && errors.password.type === "minLength" && 
            <p className="warnMessage">The password is too short</p>
          }
        </fieldset>
        <Row>
          <Col lg={12}>
            <div className={classes.Remember_Forgot_Wrap}>
              <div className="Checkbox_Wrap">
                <input
                  label="Remember me"
                  type="checkbox"
                  name="remember_me"
                  id="remember_me"
                  ref={register()}
                />
                <label htmlFor="remember_me">Remember me</label>
              </div>
            <Link to="/recover-password">
              Forgot your password?
            </Link>
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
        <Row>
          <Col className="text-center">
            <Button 
              type="submit"
              width="w-100 py-3"
              label="Sign In"
            />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default SignInForm;
